/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    TrackingMelcoModelsError,
    TrackingMelcoModelsErrorFromJSON,
    TrackingMelcoModelsErrorToJSON,
    TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummary,
    TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummaryFromJSON,
    TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummaryToJSON,
} from '../models';

export interface TrackingApiAnalyticDailyDesignSummaryRequest {
    productCode?: string;
    startTimestamp?: Date;
    endTimestamp?: Date;
}

export interface TrackingApiAnalyticExportAllDownloadSummaryRequest {
    productCode?: string;
    startTimestamp?: Date;
    endTimestamp?: Date;
    format?: string;
}

export interface TrackingApiAnalyticExportDownloadSummaryRequest {
    productCode?: string;
    startTimestamp?: Date;
    endTimestamp?: Date;
    format?: string;
}

/**
 * 
 */
export class TrackingApi extends runtime.BaseAPI {

    /**
     */
    async analyticDailyDesignSummaryRaw(requestParameters: TrackingApiAnalyticDailyDesignSummaryRequest): Promise<runtime.ApiResponse<TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummary>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.productCode !== undefined) {
            queryParameters['product_code'] = requestParameters.productCode;
        }

        if (requestParameters.startTimestamp !== undefined) {
            queryParameters['start_timestamp'] = (requestParameters.startTimestamp as any).toISOString();
        }

        if (requestParameters.endTimestamp !== undefined) {
            queryParameters['end_timestamp'] = (requestParameters.endTimestamp as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/analytics/designs/downloads/dailysummary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummaryFromJSON(jsonValue));
    }

    /**
     */
    async analyticDailyDesignSummary(requestParameters: TrackingApiAnalyticDailyDesignSummaryRequest): Promise<TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummary> {
        const response = await this.analyticDailyDesignSummaryRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async analyticExportAllDownloadSummaryRaw(requestParameters: TrackingApiAnalyticExportAllDownloadSummaryRequest): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.productCode !== undefined) {
            queryParameters['product_code'] = requestParameters.productCode;
        }

        if (requestParameters.startTimestamp !== undefined) {
            queryParameters['start_timestamp'] = (requestParameters.startTimestamp as any).toISOString();
        }

        if (requestParameters.endTimestamp !== undefined) {
            queryParameters['end_timestamp'] = (requestParameters.endTimestamp as any).toISOString();
        }

        if (requestParameters.format !== undefined) {
            queryParameters['format'] = requestParameters.format;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/analytics/designs/downloads/dailysummary/export/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async analyticExportAllDownloadSummary(requestParameters: TrackingApiAnalyticExportAllDownloadSummaryRequest): Promise<Blob> {
        const response = await this.analyticExportAllDownloadSummaryRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async analyticExportDownloadSummaryRaw(requestParameters: TrackingApiAnalyticExportDownloadSummaryRequest): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.productCode !== undefined) {
            queryParameters['product_code'] = requestParameters.productCode;
        }

        if (requestParameters.startTimestamp !== undefined) {
            queryParameters['start_timestamp'] = (requestParameters.startTimestamp as any).toISOString();
        }

        if (requestParameters.endTimestamp !== undefined) {
            queryParameters['end_timestamp'] = (requestParameters.endTimestamp as any).toISOString();
        }

        if (requestParameters.format !== undefined) {
            queryParameters['format'] = requestParameters.format;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/analytics/designs/downloads/dailysummary/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async analyticExportDownloadSummary(requestParameters: TrackingApiAnalyticExportDownloadSummaryRequest): Promise<Blob> {
        const response = await this.analyticExportDownloadSummaryRaw(requestParameters);
        return await response.value();
    }

}
